import React from 'react';
import { Loader } from 'semantic-ui-react';
import _ from 'underscore';

import './style.css';

const EcardDisplay = (props) => {
    if (!props.benefits || !props.configBenefit) {
        return <Loader active />;
    }
    const {showFront} = props;
    if (showFront === false) {
        return (
            <div className="ecard-back-cover" />
        );
    }
    const {
        name,
        nric,
        panelBenefits,
        companyName,
        companyCode
    } = props.benefits;
    const {
        planName,
        coverageDate
    } = props.configBenefit.plan[0];
    return (
        <div className="ecard-front-cover" >
            <div className="ecard-front-cover-text">
                <div className="ecard-front-cover-row-spacer">
                    <div className="ecard-front-cover-text-desc-spacer">
                        COMPANY
                    </div>
                    <div className="ecard-front-cover-text-spacer">
                        : {companyName}
                    </div>
                </div>
                &nbsp;
                <div className="ecard-front-cover-row-spacer">
                    <div className="ecard-front-cover-text-desc-spacer">
                        POLICY NO.
                    </div>
                    <div className="ecard-front-cover-text-spacer">
                        : {companyCode}
                    </div>
                </div>
                &nbsp;
                <div className="ecard-front-cover-row-spacer">
                    <div className="ecard-front-cover-text-desc-spacer">
                        NAME
                    </div>
                    <div className="ecard-front-cover-text-spacer">
                        : {name}
                    </div>
                </div>
                &nbsp;
                <div className="ecard-front-cover-row-spacer">
                    <div className="ecard-front-cover-text-desc-spacer">
                        EFFECTIVE DATE
                    </div>
                    <div className="ecard-front-cover-text-spacer">
                        : {coverageDate}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EcardDisplay;

// <div style={{backgroundImage: 'url("/ecard_front.jpg")', backgroundSize: 'contain', width: 500, height: 330}}>
